import React, { useState } from 'react';

import { isValidPhone } from '../../utils/phone';
import { isValidEmail } from '../../utils/email';

import PrivacyCheckbox from '../privacy-policy';

import Feedback from '../../components/feedback/index';

import {
  StepperContainer,
  StepContent,
  StepText,
  StepperHeader,
  ProgressBar,
  ProgressStep,
  PrevButton,
  NextButton,
  LeftArrowIcon,
  RightArrowIcon,
  ButtonGroup,
} from '../../styled/stepper';

const isStepValid = (stepIndex, formData, roomsData, selectedCity, amenities) => {
  switch (stepIndex) {
    case 0: // Location step
      return Boolean(selectedCity && formData.district && formData.district !== '');

    case 1: // Property info step
      const hasRequiredPropertyInfo = Boolean(
        formData.squareMeters && formData.rooms && formData.bathrooms && formData.floor
      );
      const hasAtLeastOneAmenity = Object.values(amenities).some((value) => value);
      return hasRequiredPropertyInfo && hasAtLeastOneAmenity;

    case 2: // Room details step
      if (!roomsData || roomsData.length === 0) return false;
      return roomsData.every((room) => room && room.size_range && room.exposure);

    case 3: // Personal info step
      return Boolean(
        formData.name &&
          formData.email &&
          isValidEmail(formData.email) &&
          formData.phone &&
          isValidPhone(formData.phone)
      );

    case 4: // Final calculation step
      return Boolean(formData.privacyAccepted); // Ensure it's explicitly converted to boolean

    default:
      return false;
  }
};

const Stepper = ({
  steps,
  initialStep = 0,
  onComplete,
  formData,
  roomsData,
  selectedCity,
  amenities,
  onInputChange,
  isFeedback,
  error,
}) => {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const isLastStep = currentStep === steps.length - 1;

  const handleNext = () => {
    const isValid = isStepValid(currentStep, formData, roomsData, selectedCity, amenities);

    if (!isValid) {
      return;
    }

    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else if (onComplete) {
      onComplete();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const isCurrentStepValid = isStepValid(currentStep, formData, roomsData, selectedCity, amenities);

  const handlePrivacyChange = (checked) => {
    onInputChange('privacyAccepted', checked);
  };

  return (
    <StepperContainer>
      {isFeedback ? (
        <Feedback error={error} />
      ) : (
        <>
          <StepperHeader>
            <StepText>
              {currentStep + 1}/{steps.length} {steps[currentStep].title}
            </StepText>
            <ProgressBar>
              {steps.map((_, index) => (
                <ProgressStep key={index} active={index <= currentStep} />
              ))}
            </ProgressBar>
          </StepperHeader>

          <StepContent>
            {steps[currentStep].content}
            {isLastStep && (
              <PrivacyCheckbox
                checked={Boolean(formData.privacyAccepted)}
                onChange={handlePrivacyChange}
              />
            )}
          </StepContent>

          <ButtonGroup>
            {currentStep > 0 && (
              <PrevButton onClick={handlePrev}>
                <LeftArrowIcon />
                Paso anterior
              </PrevButton>
            )}

            <NextButton onClick={handleNext} disabled={!isCurrentStepValid}>
              {isLastStep ? 'Finalizar' : 'Siguiente'}
              {!isLastStep && <RightArrowIcon />}
            </NextButton>
          </ButtonGroup>
        </>
      )}
    </StepperContainer>
  );
};

export default Stepper;
